export function trackData (data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function hashSha256(string) {
  return crypto.subtle.digest("SHA-256", string);
}

export function normalizeEmailForUserHash(email) {
  let emailArr = email.split('@'),
      emailUserName = emailArr[0],
      emailDomain = emailArr[1];

  // remove '+'
  if(emailArr[0].indexOf('+') > -1) {
    emailUserName = emailArr[0].split('+');
    emailUserName = emailUserName[0];
  }

  // remove '.' and set to lowercase for gmail/googlemail
  if(/^(gmail|googlemail)\.com\s*/.test(emailDomain)) {
    emailUserName = emailUserName.toLowerCase();
    emailUserName = emailUserName.split('.').join("");
  }

  return emailUserName + '@' + emailDomain;
}

export function getStudioUidByName(name) {
  const studios = JSON.parse(window.location_finder_studios);

  if(studios instanceof Array) {
    return studios.filter((studio) => studio.name == name)[0]?.id || '';
  } else {
    return  Object.values(studios?.studios).filter((studio) => studio.name == name)[0]?.id || '';
  }
}

export function getStudioByName(name) {
  const studios = JSON.parse(window.location_finder_studios);

  if(studios instanceof Array) {
    return studios.filter((studio) => studio.name == name)[0] || {};
  } else {
    return Object.values(studios?.studios).filter((studio) => studio.name == name)[0] || {};
  }
}